import { render, staticRenderFns } from "./yuyi.vue?vue&type=template&id=d70990ea&scoped=true&"
import script from "./yuyi.vue?vue&type=script&lang=ts&"
export * from "./yuyi.vue?vue&type=script&lang=ts&"
import style0 from "./yuyi.vue?vue&type=style&index=0&id=d70990ea&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d70990ea",
  null
  
)

export default component.exports